import React from 'react'
import { Link } from 'react-router-dom'
import toJS from '../hoc/toJS.jsx'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { DAY_FILTER_ID, FILTER_WEEK_DAYS_ID, getWeekOtherFilters, useWeekFilter, useWeekFilterSortValue } from '../Overview/OverviewFilter/WeekFilter'
import { TRANSLATION_CURRENT_LANG } from '../constants/state'
import getData from '../functions/getData.js'
import TranslationCont from '../General/TranslationCont.jsx'
import { useFilterValues } from '../Overview/HooksOverview/useFilterValues.js'

const mapStateToProps = (state, ownProps) => ({
    currentLang: getData(state, TRANSLATION_CURRENT_LANG),
})


const WeekFilterAccess = ({
    queryStringValues,
    filterStrings,
    dayFilters,
    currentLang //ToDO
}) => {
    const filterValues = useFilterValues(queryStringValues, DAY_FILTER_ID)
    const otherFilters = getWeekOtherFilters(filterStrings)

    return (
        <div className="access-filter access-filter-prim">
            <nav aria-labelledby="filter-1">
                <h3 id="filter-1" className="access-filter-title access-typo">
                    <TranslationCont id="dayFilters" uppercase={true}>Wochenfilter</TranslationCont>
                </h3>

                <ul className="access-overview-filter-list">
                    {Object.keys(dayFilters).map((filterId, index) => {
                        if(filterId === FILTER_WEEK_DAYS_ID) {
                            return ''
                        }
                        
                        const [items, displayName] = useWeekFilter(dayFilters, filterId, currentLang)

                        const [className, sortValue] = useWeekFilterSortValue(
                            filterId,
                            filterValues,
                            otherFilters
                        )

                        const isNotInactive = items && items.length > 0 || filterId === 'all'

                        return (
                            <li key={index} className={"filter-item" + className + ' ' + filterId}>
                                {isNotInactive ? (
                                    <Link key={index} className="filter-button title-large access-typo" to={{search: sortValue}}>
                                        {displayName}
                                    </Link>
                                ) : (
                                    <span key={index} className="filter-button title-large access-typo filter-inactive">
                                        {displayName}
                                    </span>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </nav>
        </div>
    )
}


export default compose(
    connect(mapStateToProps, null),
    toJS()
)(WeekFilterAccess)